// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import store from './store'
import i18n from './i18n'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import App from './App'

Vue.config.productionTip = false
Vue.use(BootstrapVue)

let root = new Vue({
  ...App,
  i18n,
  store,
  router,
})

document.addEventListener('DOMContentLoaded', function() {
  root.$mount('#app')
})
